import {keepPreviousData, useQuery} from '@tanstack/react-query';
import {AxiosHttpClient} from '../../envisia/auth/axios-http-client';
import {environment} from '../../../environments/environment';
import {ArticleMultilayerPlan} from '../../envisia/article/main/multilayer-plan/article-multilayer-plan.models';
import {queryKey} from './multilayer-plan-query-keys';
import Helper from '../../helper/helper';

interface Props {
  sharedId?: string;
}

export function useMultilayerPlanListQuery({sharedId}: Props) {
  const {data, isSuccess, isEnabled} = useQuery({
    queryKey: queryKey.single(sharedId),
    queryFn: () =>
      AxiosHttpClient.get<ArticleMultilayerPlan>(`${environment.apiv4uri}multilayerplan/${sharedId}`),
    enabled: !Helper.undefined(sharedId),
    placeholderData: keepPreviousData,
    retry: false,
  });

  return {
    data: data ?? null,
    isEnabled,
    isSuccess,
  };
}
